module.exports = __webpack_public_path__ + "static/img/Compvsesvit.2ac49c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/nets/Compvsesvit.png
// module id = 3u0k
// module chunks = 0